import { useMemo } from 'react';
import { useAuth } from '@/lib/auth/useAuth';
import { ApiClient } from './client';

export function useApiClient(): ApiClient {
  const { accessToken } = useAuth();
  // The token changes on refresh, so memoise per-token. The closure
  // captures the latest token via a stable getter to avoid stale fetches.
  return useMemo(
    () =>
      new ApiClient({
        getToken: () => accessToken,
      }),
    [accessToken],
  );
}
